/**
 * Hasła admina tylko w pamięci procesu — nigdy w IndexedDB.
 * Po zamknięciu karty znikają; drain wtedy ustawi needs_password.
 */

const byClientId = new Map<string, string>();

export function rememberOutboxPassword(clientId: string, password: string): void {
  byClientId.set(clientId, password);
}

export function peekOutboxPassword(clientId: string): string | undefined {
  return byClientId.get(clientId);
}

export function forgetOutboxPassword(clientId: string): void {
  byClientId.delete(clientId);
}
